// Shared CARTO Voyager basemap tile configuration for MapScreen and
// StudiZoneMapScreen. The actual API key lives in `cartoConfig.local.ts`
// (gitignored, never committed) — see `cartoConfig.local.example.ts` for
// the template and where to get a key.
//
// CARTO's documented tile authentication format is a `key` query parameter:
// https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png?key=YOUR_KEY
import { CARTO_API_KEY } from './cartoConfig.local';

const CARTO_TILE_BASE = 'https://a.basemaps.cartocdn.com/rastertiles/voyager';

export { CARTO_API_KEY };
export const CARTO_VOYAGER_TILE_URL = `${CARTO_TILE_BASE}/{z}/{x}/{y}@2x.png?key=${CARTO_API_KEY}`;
export const CARTO_VOYAGER_STANDARD_TILE_URL = `${CARTO_TILE_BASE}/{z}/{x}/{y}.png?key=${CARTO_API_KEY}`;
